import { RTRequest } from '../../../business/cargo';
import { initialRTRequest } from '../../../business/cargo/infra/core/consts';

export const CARGO_UI_STATUS = {
  idle: 'idle',
  form: 'form',
  coverage: 'coverage',
  list: 'list',
};
export type CargoUIStatus = keyof typeof CARGO_UI_STATUS;

export interface CargoState {
  isOpen: boolean;
  status: CargoUIStatus;
  isOpenCancelDialog: boolean;
  isDropDownOpen: boolean;
  selectedOrder: number;
  orderRT: Partial<RTRequest>;
}

export const initialValue: CargoState = {
  isOpen: false,
  status: 'idle',
  isOpenCancelDialog: false,
  isDropDownOpen: false,
  selectedOrder: 0,
  orderRT: initialRTRequest,
};
